const STORAGE_KEY = "app-banner-dismissed";
const DISMISS_TTL_MS = 7 * 24 * 60 * 60 * 1000;

export const IOS_URL = "https://apps.apple.com/au/app/tldr/id6757189366";
/** The Android app the site sends people to: the listing of com.nottldr.app.android until com.nottldr.android is live. */
export const ANDROID_URL = "https://play.google.com/store/apps/details?id=com.nottldr.android";

export type StorePlatform = "ios" | "android";

export const detectPlatform = (): StorePlatform | null => {
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) {
    return "android";
  }
  if (/iPhone|iPad|iPod/i.test(ua)) {
    return "ios";
  }
  return null;
};

export const isDismissed = (): boolean => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return false;
    }
    const data = JSON.parse(raw);
    if (data.dismissed && data.expiry > Date.now()) {
      return true;
    }
    localStorage.removeItem(STORAGE_KEY);
    return false;
  } catch {
    return false;
  }
};

export const dismiss = (): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ dismissed: true, expiry: Date.now() + DISMISS_TTL_MS }));
  } catch {
    // The banner then shows again on the next visit.
  }
};
